import React, { lazy, Suspense, useEffect } from 'react';
import { Divider, Box, Grid2 as Grid, Tab, Tabs } from '@mui/material';
import { useRole } from '../components/utils/AclProvider';
import { Actions, useDispatchProvider, useStateTabsDashboard } from '../components/utils/StateProvider';
import CardCollectionCount from '../components/cards/CardCollectionCount';
import CardProductsStatus from '../components/cards/CardProductsStatus';
import CardOrdersStatus from '../components/cards/CardOrdersStatus';
import Loader from '../components/utils/Loader';
const ListOrdersDashboard = lazy(() => import('../components/lists/ListOrdersDashboard'));

const Dashboard = () => {
  const role = useRole();
  const stateTabsDashboard = useStateTabsDashboard();
  const dispatch = useDispatchProvider();

  const handleChangeTab = (event, newValue) => {
    dispatch && dispatch({ type: Actions.TabsDashboard, payload: newValue });
  };

  useEffect(() => {
    document.title = `Warehouse Lefkada - Dashboard`;
  }, []);

  if (role === 'guest') return null;
  return (
    <>
      <Box
        pb={3}
        mt={-2}
      >
        <Tabs
          value={stateTabsDashboard}
          onChange={handleChangeTab}
          variant={'scrollable'}
          scrollButtons={'auto'}
          // variant="fullWidth"
        >
          <Tab
            label="Statistics"
            value="stats"
            sx={{ height: 64 }}
          />
          <Tab
            label="New orders"
            value="new"
            sx={{ height: 64 }}
          />
          <Tab
            label="Ready orders"
            value="ready"
            sx={{ height: 64 }}
          />
          {role === 'admin' && (
            <Tab
              label="Unpaid orders"
              value="unpaid"
              sx={{ height: 64 }}
            />
          )}
        </Tabs>
        <Divider />
      </Box>
      {stateTabsDashboard === 'new' && (
        <Suspense fallback={<Loader />}>
          <ListOrdersDashboard status={'new'} />
        </Suspense>
      )}
      {stateTabsDashboard === 'ready' && (
        <Suspense fallback={<Loader />}>
          <ListOrdersDashboard status={'ready'} />
        </Suspense>
      )}
      {role === 'admin' && stateTabsDashboard === 'unpaid' && (
        <Suspense fallback={<Loader />}>
          <ListOrdersDashboard status={'unpaid'} />
        </Suspense>
      )}
      {stateTabsDashboard === 'stats' && (
        <Box sx={{ overflowY: 'auto', height: '100%', pb: 3 }}>
          <Grid
            container
            spacing={3}
          >
            {/*<Grid size={12}>*/}
            {/*  <TableProductsNewDashboard />*/}
            {/*</Grid>*/}
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardProductsStatus
                title={'Products to be ordered'}
                status={'new'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardProductsStatus
                title={'Products to be received'}
                status={'ordered'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardProductsStatus
                title={'Products for delivery'}
                status={'received'}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Divider />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardOrdersStatus
                title={'New orders'}
                status={'new'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardOrdersStatus
                title={'Ready orders'}
                status={'ready'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardOrdersStatus
                title={'Called orders'}
                status={'called'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardOrdersStatus
                title={'Unpaid orders'}
                status={'unpaid'}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Divider />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'orders'}
                collectionName={'orders'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'products'}
                collectionName={'products'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'suppliers'}
                collectionName={'suppliers'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'customers'}
                collectionName={'customers'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'Transactions'}
                collectionName={'transactions'}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CardCollectionCount
                title={'users'}
                collectionName={'users'}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Dashboard;
